import { Brand } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";

export class CommandGetOrganizationBrand {
    async run(organizationId: string) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return this.deserialize(response[0]);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Brand{
        const serializer = new BrandSerializer();
        return serializer.deserialize(data);
    }

  
}



